import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useNotification } from '../context/NotificationContext';
import { formatMobileForDisplay } from '../utils/mobileUtils';
import { apiFetch } from '../utils/api';
import { userFacingApiError } from '../utils/userMessages';
import './Profile.css';

function Profile() {
  const { user, updateUser } = useAuth();
  const { isDarkMode } = useTheme();
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      if (user.name) {
        setName(user.name);
      }
      fetchUserData();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.mobile]);

  const fetchUserData = async () => {
    if (!user?.mobile) {
      setLoading(false);
      return;
    }
    try {
      const response = await apiFetch(`/api/auth/user/${encodeURIComponent(user.mobile)}`);
      if (response.ok) {
        const userData = await response.json();
        setName(userData.name || '');
        updateUser(userData);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!user) {
      showNotification('لطفاً ابتدا وارد شوید', 'error');
      navigate('/login');
      return;
    }
    setSaving(true);
    try {
      const response = await apiFetch(`/api/auth/user/${encodeURIComponent(user.mobile)}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name || '' })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        updateUser(data.user);
        showNotification('اطلاعات با موفقیت ذخیره شد', 'success');
        setTimeout(() => navigate('/dashboard'), 500);
      } else {
        showNotification(userFacingApiError(data, 'خطا در ذخیره اطلاعات'), 'error');
      }
    } catch (error) {
      showNotification('خطا در ذخیره اطلاعات', 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className={`profile-container ${isDarkMode ? 'dark' : ''}`}>
        <div className="profile-box">
          <div className="loading">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className={`profile-container ${isDarkMode ? 'dark' : ''}`}>
        <div className="profile-box">
          <p>لطفاً ابتدا وارد شوید</p>
          <button className="btn-primary" onClick={() => navigate('/login')}>ورود</button>
        </div>
      </div>
    );
  }

  return (
    <div className={`profile-container ${isDarkMode ? 'dark' : ''}`}>
      <div className="profile-box">
        <h1>تکمیل اطلاعات</h1>
        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>شماره موبایل</label>
            <input type="tel" value={formatMobileForDisplay(user.mobile)} disabled className="disabled-input" />
          </div>
          <div className="form-group">
            <label>نام و نام خانوادگی</label>
            <input
              type="text"
              name="name"
              id="profile-name-input"
              value={name || ''}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              placeholder="نام خود را وارد کنید"
              autoComplete="name"
              style={{ pointerEvents: 'auto', cursor: 'text' }}
            />
          </div>
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? 'در حال ذخیره...' : 'ذخیره اطلاعات'}
          </button>
        </form>
        <button className="back-link" onClick={() => navigate(-1)}>→ بازگشت</button>
      </div>
    </div>
  );
}

export default Profile;
